import { BadgeStatus } from "@/components/badgeStatus"
import { LogoHeader } from "@/components/logoHeader"
import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { pedagogico } from "@/constants/pedagogico"
import { secretaria_financeiro } from "@/constants/secretaria_financeiro"
import { getSolicitacao } from "@/http/getSolicitacao"
import { useQuery } from "@tanstack/react-query"
import { CirclePlus, LoaderCircle, SquareArrowOutUpRight } from "lucide-react"
import moment from "moment"
import { Link, Navigate, useLocation } from "react-router-dom"

const setores = {
  pedagogico: "Pedagógico",
  financeiro: "Financeiro",
};

function Solicitacoes() {
  const location = useLocation();

  if (!location.state) return <Navigate to="/" replace />

  const cpf = location?.state

  const { data, isLoading, isError } = useQuery({
    queryKey: ['solicitacao', cpf],
    queryFn: () => getSolicitacao({ cpf }),
    retry: true
  })

  if (isError) return <Navigate to="/" replace />

  if (isLoading) {
    return (
      <div className="flex flex-col gap-2 h-screen justify-center items-center">
        <LoaderCircle className="animate-spin text-slate-400 size-10" />
        <p className="text-zinc-300 text-center">Buscando..</p>
      </div>
    )
  }

  return (
    <div className="mx-auto max-w-[500px] pb-8">
      <LogoHeader />
      <div className="min-h-[90px] bg-white flex flex-col justify-center px-4">
        <div className="flex flex-row justify-between items-center">
          <p className="text-2xl font-bold text-zinc-600">Solicitações</p>
        </div>
      </div>

      <div className="mt-2 p-4 flex flex-col gap-4">
        <p className="font-semibold">Todas solicitações</p>
        {data?.map(item => (
          <CardRow key={item._id} data={item} />
        ))}
      </div>

      <div className="p-4 flex flex-col gap-3">
        {data && data.length === 0 && <AlertSemSolicitacao />}
        <Link to="/">
          <Button className="w-full bg-emerald-700 hover:bg-emerald-600 cursor-pointer">
            <CirclePlus />
            Nova solicitação
          </Button>
        </Link>
      </div>

    </div>
  )
}

export default Solicitacoes

function AlertSemSolicitacao() {
  return (
    <div className="flex items-center justify-center bg-white/60 px-4 py-2 rounded-md">
      <p className="text-[11px] text-zinc-400 leading-relaxed">Você ainda não fez nenhuma solicitação.</p>
    </div>
  )
}

function CardInfo({ label, value, divider, helpText }) {
  return (
    <div className={`px-4 py-2 flex flex-row justify-between items-center  ${divider ? "border-b" : "border-0"} border-border`}>
      <div className="flex flex-row items-center">
        <p className="font-bold">{label}</p>
        {helpText && <TooltipInfo helpText={helpText} />}
      </div>
      <p className="text-zinc-400">{value}</p>
    </div>
  )
}

function CardStatus({ label, finalizado, inProgress, divider }) {
  return (
    <div className={`px-4 py-2 flex flex-row justify-between items-center  ${divider ? "border-b" : "border-0"} border-border`}>
      <div className="flex flex-row items-center">
        <p className="font-bold">{label}</p>
      </div>
      <BadgeStatus finalizado={finalizado} inProgress={inProgress} />
    </div>
  )
}

function CardRow({ data }) {

  const setor = setores[data?.setor] || "Secretaria";
  const servicos = data?.setor === "pedagogico" ? pedagogico : secretaria_financeiro
  const servico = servicos?.find(element => element.id === data?.servico);

  return (
    <div className="flex flex-col bg-white rounded-md border border-border py-3 px-2">
      <CardStatus divider label="Situação" finalizado={data.finalizado} inProgress={data.inProgress} />
      <CardInfo divider label="Serviço" value={servico ? servico.label : ""} />
      <CardInfo divider label="Setor" value={setor} />
      <CardInfo label="Enviado" value={data ? moment(data.createdAt).format("DD/MM/YY HH:mm") : ""} />
      <Link to={`/solicitacoes/${data._id}`}>
        <Button className="w-full mt-2">
          <SquareArrowOutUpRight />
          Visualizar
        </Button>
      </Link>
    </div>
  )
}